export enum UserStatus {
  ENABLED = 1,
  HIDDEN = 2,
  ARCHIVED = 3,
}
